@if (bulkPending) {
<span class="bulk-clear-pending">Will clear for all</span>
<button mat-icon-button mgdButton type="button" class="mat-bulk-clear-undo-icon-button" aria-label="Undo clear"
  (click)="onUndoClick()" [disabled]="disabled">
  <mat-icon>
    undo
  </mat-icon>
</button>
}
@else if (showButton) {
<button tabindex="-1" mat-icon-button mgdButton type="button" (click)="onClearClick()" [disabled]="disabled">
  <mat-icon>
    clear
  </mat-icon>
</button>
}
